import Experience from "../Experience.js"
import Environment from './Environment.js'
import Mizuburo from './Mizuburo.js'
import Afro from './Afro.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resouces = this.experience.resources


        //

        // Wait for resources
        this.resouces.on('ready', () =>
        {
            // Setup
            this.mizuburo = new Mizuburo()
            this.afro = new Afro()
            this.environment = new Environment()
        })
    }

    update()
    {
        if(this.afro)
            this.afro.update()
    }
}